import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Stack } from '@mui/material';

import { AppDispatch, RootState } from 'redux/store';
import { setMyPicture, removeMyPicture } from 'redux/slices/user/userSlice';
import ChangePhoto from 'pages/Account/ChangePhoto';
import CustomButton from 'components/Common/Button';
import CardWrapper from 'components/Common/CardWrapper';

function AccountChangePhoto() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const userImg = useSelector((state: RootState) => state.user.userInfo?.imgUrl);
    const [imgValue, setImgValue] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (userImg) {
            setImgValue(userImg);
        } else {
            setImgValue('');
        }
    }, [userImg, dispatch]);

    const onSaveClick = async () => {
        const formData = new FormData();
        formData.append('file', imgValue);
        try {
            setLoading(true);
            const res: any = await dispatch(setMyPicture({ formData: formData }));
            if (res.payload?.code === 200) {
                userImg && setImgValue(userImg);
                navigate(-1);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log('upload img error');
        }
    };

    const onRemoveClick = async () => {
        // if user select an image and has not previously been uploaded the image then no need to call remove picture
        if (!userImg) {
            return setImgValue('');
        }
        try {
            setLoading(true);
            const res: any = await dispatch(removeMyPicture());
            if (res.code === 200) {
                setImgValue('');
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log('remove img error');
        }
    };

    return (
        <CardWrapper>
            <Stack justifyContent="center">
                {/* Component Which Has The Option To Upload/Select Images */}
                <ChangePhoto isLoading={loading} onRemoveClick={onRemoveClick} imgValue={imgValue} setImgValue={setImgValue} />
                {imgValue && (
                    <Stack width="100%" alignItems="center" mt={4}>
                        <CustomButton
                            disabled={typeof imgValue === 'string'}
                            width="30%"
                            title="Save"
                            loading={loading}
                            onClick={onSaveClick}
                        />
                    </Stack>
                )}
            </Stack>
        </CardWrapper>
    );
}

export default AccountChangePhoto;
